import React, { useState, useEffect } from "react";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCountryName } from "../../Utils/Helper";
import { getCompanyListAPI, getMasterCountryList, vendorbililingAPi } from "../../../api/api";
import useSelectedDate from "../../../store/UseFilterDateStore";
import { type } from "../../common/AdminAuth";

const VendorBilling = () => {

    const selctedDateFrom = useSelectedDate((state) => state.selctedDateFrom);
    const selctedDateTo = useSelectedDate((state) => state.selctedDateTo);

    const [error, seterror] = useState({
        errarStatus: false,
        errorMessage: "",
        bgcolor: "",
    });

    var date = new Date();
    var todatdate =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        ("0" + date.getDate()).slice(-2);
    const [companyList, setcompanyList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [DateFrom, setDateFrom] = useState(selctedDateFrom);
    const [DateTo, setDateTo] = useState(selctedDateTo);
    const [showDateFrom, setshowDateFrom] = useState(new Date(selctedDateFrom));
    const [showDateTo, setshowDateTo] = useState(new Date(selctedDateTo));
    const [selectedCompany, setselectedCompany] = useState("");
    const [selectedCompanyID, setSelectedCompanyID] = useState("");
    const [billingData, setBillingData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [method, setMethod] = useState('ven_summary_all');


    const detailsReport = () => {
        setBillingData([]);
        setIsLoading(true);
        vendorbililingAPi(method, DateFrom, DateTo, selectedCompanyID).then((result) => {
            if (result.data.success === true) {
                seterror({ errarStatus: false });
                createNewObject(result.data.data);
                setIsLoading(false);
            } else {
                seterror({
                    errarStatus: true,
                    errorMessage: result.data.message,
                    bgcolor: "alert alert-danger",
                });
                setIsLoading(false);
            }
        })
    };

    const createNewObject = (data) => {
        let overallTotalCost = 0;
        let overallTotalSubmission = 0;

        const result = {};
        for (const key in data) {
            let mainKeyTotalCost = 0;
            let totalSubmition = 0;

            for (const nestedKey in data[key]) {
                for (const rateKey in data[key][nestedKey]) {
                    const stats = data[key][nestedKey][rateKey];
                    if (stats.totalcost) {
                        mainKeyTotalCost += parseFloat(stats.totalcost);
                    }
                    const submissions =
                        parseFloat(stats.delivered || 0) +
                        parseFloat(stats.failed || 0) +
                        parseFloat(stats.other || 0);
                    overallTotalSubmission += submissions;
                    totalSubmition += submissions;
                }
            }

            result[key] = {
                totalcost: mainKeyTotalCost.toFixed(5),
                totalSubmition: totalSubmition,
                other: data[key],
            };
            overallTotalCost += mainKeyTotalCost;
        }

        result.overallSubmission = overallTotalSubmission;
        result.overallTotalCost = overallTotalCost.toFixed(5);
        setBillingData(result);
    };

    useEffect(() => {
        getMasterCountryList().then((res) => {
            if (res.data.success === true) {
                setCountryList(res.data.data);
            } else {
                setCountryList([]);
            }
        });
    }, []);

    useEffect(() => {
        getCompanyList();
    }, []);

    const getCompanyList = () => {
        getCompanyListAPI().then((res) => {
            //console.log("res", res.data);
            if (res.data.success === true) {
                setcompanyList(res.data.data);
            } else {
                setcompanyList([]);
            }
        });
    };

    const handleDateFrom = (date) => {
        let dated =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            ("0" + date.getDate()).slice(-2);
        setDateFrom(dated);
        setshowDateFrom(date);
    };

    const handleDateTo = (date) => {
        let dated =
            date.getFullYear() +
            "-" +
            (date.getMonth() + 1) +
            "-" +
            ("0" + date.getDate()).slice(-2);
        setDateTo(dated);
        setshowDateTo(date);
    };

    const userhandlar = (e) => {
        const select = e.target;
        const desc = select.selectedOptions[0].text;
        if (e.target.value === 'all') {
            setMethod('ven_summary_all');
        } else {
            setMethod('ven_summary_companywise');
        }
        setselectedCompany(desc)
        setSelectedCompanyID(e.target.value);
    };

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <AdminSideMenu />
                <div className="layout-page">
                    <AdminTopMenu />
                    <div className="content-wrapper">
                        <div className="container-xxl container-p-y">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card  mb-4">
                                        <h5 className="card-header">Vendor Billing </h5>

                                        <div className="card-body ">
                                            <div className="row gy-3">
                                              {type === "Admin" &&
                                               <div className="col-md-3">
                                                    <label>Company</label>
                                                    <div className="input-group">
                                                        <select
                                                            value={selectedCompanyID}
                                                            onChange={userhandlar}
                                                            name="selected-user"
                                                            className="form-select"
                                                        >
                                                            <option value="all">All Company  </option>
                                                            {companyList.map((items, i) => (
                                                                <option key={i} id="box1" value={items.id}>
                                                                    {items.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>}

                                                <div className={type === "Admin" ? "col-md-3" : "col-md-4"}>
                                                    <label>From Date</label>
                                                    <div className="">
                                                        <DatePicker
                                                            className="form-control btn-block"
                                                            dateFormat="MM/dd/yyyy"
                                                            selected={showDateFrom}
                                                            onChange={handleDateFrom}
                                                            placeholderText={todatdate}
                                                            maxDate={new Date()}
                                                        />
                                                    </div>
                                                </div>
                                                <div className={type === "Admin" ? "col-md-3" : "col-md-4"}>
                                                    <label> Date To</label>
                                                    <div className="input-group">
                                                        <DatePicker
                                                            startDate={showDateTo}
                                                            className="form-control btn-block"
                                                            dateFormat="MM/dd/yyyy"
                                                            selected={showDateTo}
                                                            onChange={handleDateTo}
                                                            placeholderText={todatdate}
                                                            minDate={new Date(showDateFrom)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className={type === "Admin" ? "col-md-3" : "col-md-4"}>
                                                    <label>&nbsp;</label>
                                                    <div className="input-group">
                                                        {isLoading ? (
                                                            <button className="btn btn-block btn-primary me-1">
                                                                <FontAwesomeIcon icon={faSearch} /> Loading...
                                                            </button>
                                                        ) : (
                                                            <button
                                                                onClick={detailsReport}
                                                                className="btn btn-block btn-primary me-1"
                                                            >
                                                                <FontAwesomeIcon icon={faSearch} /> Search
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-12 col-md-12 order-1">
                                    <div className="">
                                        {error.errarStatus ? (
                                            <div className={error.bgcolor} role="alert">
                                                <strong>Alert!</strong> {error.errorMessage}
                                            </div>
                                        ) : null}

                                        {billingData && (
                                            <div className="card pb-5">
                                                <h5 className="card-header pb-0">
                                                    Total Cost of{" "}
                                                    <span className="text-primary ml-1 mr-1">
                                                        {selectedCompany ? selectedCompany : "All"}
                                                    </span>
                                                    Company is{" "}
                                                    <span className="text-info ml-1 badge badge-info text-white mr-2">
                                                        {billingData.overallTotalCost}
                                                    </span>
                                                    and total Submission is
                                                    <span className="text-info ml-2 badge badge-info text-white">
                                                        {billingData.overallSubmission}
                                                    </span>
                                                </h5>

                                                <div className="p-4">

                                                    <div className="accordion">

                                                        {
                                                            Object.keys(billingData).map((userName, i) => {
                                                                if (
                                                                    userName !== "overallTotalCost" &&
                                                                    userName !== "overallSubmission"
                                                                ) {
                                                                    return (
                                                                        <div key={i} className="card">
                                                                            <div role="button" data-toggle="collapse" data-target={`#faq${i}`}
                                                                                aria-expanded="true" aria-controls={`#faq${i}`} className="company-name" id={`faqhead${i}`}>
                                                                                <span className="btn btn-header-link">
                                                                                    <span className="text-info badge badge-dark w-50 text-white ml-2 mr-2">
                                                                                        {userName}
                                                                                    </span>
                                                                                    Total Cost :
                                                                                    <span className="text-info badge badge-info text-white ml-2 mr-2">
                                                                                        {billingData[userName]?.totalcost}
                                                                                    </span>
                                                                                    Total Submission :
                                                                                    <span className="text-info badge badge-success text-white ml-2">
                                                                                        {billingData[userName]?.totalSubmition}
                                                                                    </span>
                                                                                </span>
                                                                            </div>

                                                                            <div id={`faq${i}`} className="collapse" aria-labelledby={`faqhead${i}`} data-parent="#faq">
                                                                                <div className="card-body">
                                                                                    {Object.keys(billingData[userName].other).map((countryCode) =>
                                                                                        <React.Fragment key={countryCode}>
                                                                                            <p className="fw-semibold d-block mb-1">{getCountryName(countryList, countryCode)}</p>
                                                                                            {Object.keys(billingData[userName].other[countryCode]).map((rateKey, j) => {
                                                                                                const stats = billingData[userName].other[countryCode][rateKey];
                                                                                                return (
                                                                                                    <div className="d-flex gap-2" key={j}>
                                                                                                        <small className="d-flex gap-5 text-info">
                                                                                                            {Object.keys(stats).map((status, k) =>
                                                                                                                <p className="text-capitalize" key={k}> {status} :
                                                                                                                    {stats[status]}
                                                                                                                </p>
                                                                                                            )}

                                                                                                        </small>
                                                                                                    </div>
                                                                                                );
                                                                                            })}
                                                                                        </React.Fragment>

                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            })
                                                        }


                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorBilling;
